import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
type EnvironmentIndicatorProps = {
  environment: 'sandbox' | 'production';
  disabled?: boolean;
};
const EnvironmentIndicator = forwardRef<HTMLSpanElement, EnvironmentIndicatorProps>((t0, ref) => {
  const $ = _c(24);
  const {
    environment,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav.navHeader.sandboxToggle"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const isSandbox = environment === "sandbox";
  const t2 = !disabled;
  const t3 = !isSandbox;
  let t4;
  if ($[1] !== disabled || $[2] !== isSandbox || $[3] !== t2 || $[4] !== t3) {
    t4 = cx("rounded-full size-1.5 relative flex-shrink-0", {
      "[animation:pulse_3s_cubic-bezier(0.4,0,0.6,1)_infinite]": t2,
      "bg-warning-inverted ring-2 ring-warning-inverted text-warning-inverted": isSandbox,
      "bg-success-inverted ring-2 ring-success-inverted text-success-inverted": t3,
      "opacity-50": disabled
    });
    $[1] = disabled;
    $[2] = isSandbox;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !disabled;
  const t6 = !isSandbox;
  let t7;
  if ($[6] !== isSandbox || $[7] !== t5 || $[8] !== t6) {
    t7 = cx("absolute inset-0 rounded-full opacity-75", {
      "[animation:ping_3s_cubic-bezier(0,0,0.2,1)_infinite]": t5,
      "bg-warning-inverted": isSandbox,
      "bg-success-inverted": t6
    });
    $[6] = isSandbox;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <span className={t7} />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <span className={t4}>{t8}</span>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isSandbox || $[16] !== t) {
    t10 = isSandbox ? t(_temp) : t(_temp2);
    $[15] = isSandbox;
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <span className="text-nowrap">{t10}</span>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== ref || $[21] !== t11 || $[22] !== t9) {
    t12 = <span className="flex items-center justify-start gap-2 pl-0.5" ref={ref}>{t9}{t11}</span>;
    $[20] = ref;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
});
EnvironmentIndicator.displayName = 'EnvironmentIndicator';
export default EnvironmentIndicator;
function _temp($) {
  return $.sandbox;
}
function _temp2($_0) {
  return $_0.production;
}